import { useTheme } from '../hooks'

export default function ThemeToggle({ fixed = false }) {
  const { theme, toggle } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggle}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm transition-all ${
        fixed ? 'fixed top-4 right-4 z-50' : ''
      }`}
      style={{
        background:   isDark ? '#ffffff' : '#0f172a',
        border:       '1px solid var(--border)',
        color:        isDark ? '#0f172a' : '#ffffff',
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--brand)' }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)' }}
    >
      {isDark ? '☀' : '🌙'}
    </button>
  )
}
